import store from '../reducers'
import events from 'actions/events'
import { PageActions,ServiceRegionActions } from 'actions'

export default () => {
    events.on('Filters.componentWillMount',()=>{
        ServiceRegionActions.fetch({
            organizationID: store.getState().config.organizationID
        }).then((res)=>{
            ServiceRegionActions.set(res.data)
        })
    })

    events.on('Filters.componentDidSubmit',()=>{
        PageActions.navToCollectInformation()
    })
    
    events.on('TimeSlots.componentDidSubmit',()=>{
        PageActions.navToCollectInformation()
    })

    events.on('ContactInformation.componentDidSubmit',()=>{
        if(!store.getState().selectedTimeSlot.id){
            PageActions.navToTimeSlots()
        }
    })
    
    events.on('CollectInformation.componentDidSubmit',()=>{
        PageActions.navToConfirmation()
    })

    events.on('Confirmation.componentDidSubmit',()=>{
        PageActions.navToReceipt()
    })
}


// WEBPACK FOOTER //
// ./eventFlows/mobileVet.js